export const GroceriesIcon = () => (
  <span style={{ display: "inline-flex", marginLeft: "-3px" }}>
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="9" cy="21" r="1" />
      <circle cx="20" cy="21" r="1" />
      <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61H19a2 2 0 0 0 1.98-1.75L23 6H6" />
    </svg>
  </span>
);
